import { useProBanner } from '@src/hooks/useProBanner';
import { BiX } from 'react-icons/bi';
import { Button } from 'ui_2';

export const ProBannerAd = () => {
  const { showBannerAd, dismissAd } = useProBanner();

  if (!showBannerAd) {
    return null;
  }

  return (
    <div className='pb-safe absolute bottom-0 left-0 right-0 z-50 md:bottom-4 md:overflow-clip md:rounded-lg'>
      <div className='relative mx-auto w-screen max-w-[500px]'>
        <img
          src='https://storage.googleapis.com/bucket-quickstart_jigsaw-bigshot/Quest/ads/go_pro_banner_ad.png'
          className='w-full'
        />

        {/* Dismiss button */}
        <button
          onClick={dismissAd}
          className='absolute right-2 top-2'
          aria-label='Dismiss ad'
        >
          <BiX />
        </button>

        {/* Right section - Go Pro button */}
        <Button
          onClick={() => window.open('https://app.puzzle.online/paywall')}
          variant='black'
          className='absolute right-4 top-1/2 -translate-y-1/2 shadow-md'
        >
          Go Pro
        </Button>
      </div>
    </div>
  );
};
